import twemoji from 'twemoji';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'emoji',
  standalone: false
})
export class EmojiPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}
  transform(codePoint: string): SafeHtml {
    let c = codePoint.split('-').map(i => parseInt(i, 16));
    const castedCode = String.fromCodePoint(...c);
    return this.domSanitizer.bypassSecurityTrustHtml(
      twemoji.parse(castedCode, {
        folder: 'svg',
        ext: '.svg',
        base: 'assets/emojis/', // Ensure base is used inside options
        attributes: () => ({
          loading: 'lazy'
        })
      })
    );
  }
}
